/**
 * Top-level kind of a team calendar entry. Today every entry is owned by
 * Marketing — this enum exists so other product areas can be added later
 * without reshaping the schema.
 */
export enum TeamCalendarEntryType {
  Marketing = "marketing",
}
